module.exports = __webpack_public_path__ + "img/daizy_lulworth.9d63d8c9.jpg";